export default __webpack_public_path__ + "static/media/banner2.c62bc803.jpg";